import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconCloseDoors: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="close-doors">
    <path
      fillRule="evenodd"
      d="M6.4 9.314c-.436.08-.856.169-1.254.268l-.582.146-.292-1.164.583-.146c.488-.122 1.006-.23 1.545-.323V7A4.6 4.6 0 0 1 11 2.4h2A4.6 4.6 0 0 1 17.6 7v1.095c.54.093 1.057.201 1.546.323l.582.146-.291 1.164-.582-.146c-.4-.1-.819-.189-1.255-.268V18a3.6 3.6 0 0 1-3.6 3.6h-4A3.6 3.6 0 0 1 6.4 18V9.314ZM7.6 7A3.4 3.4 0 0 1 11 3.6h2A3.4 3.4 0 0 1 16.4 7v.917a36.494 36.494 0 0 0-8.8 0V7Zm8.141 2.047a35.695 35.695 0 0 0-7.482 0l1.852 2.161c.268-.133.57-.208.889-.208h2c.32 0 .621.075.889.208l1.852-2.161Zm.659 1.075-1.645 1.92c.156.284.245.61.245.958v2.5c0 .476-.166.912-.443 1.255l.942 1.413-.998.665-.942-1.412c-.177.052-.365.08-.559.08h-2c-.267 0-.522-.053-.755-.148l-.708 1.416-1.074-.537.838-1.676A1.99 1.99 0 0 1 9 15.5V13c0-.347.089-.674.245-.959L7.6 10.122V18a2.4 2.4 0 0 0 2.4 2.4h4a2.4 2.4 0 0 0 2.4-2.4v-7.877ZM13.8 15.5V13a.8.8 0 0 0-.8-.8h-2a.8.8 0 0 0-.8.8v2.5a.8.8 0 0 0 .8.8h2a.8.8 0 0 0 .8-.8Z"
    />
  </Icon>
);
